
class Cart {
  constructor() {
    this.fetch = window.fetch.bind(window);
  }

  async get() {
    const res = await this.fetch(getCartUrl('cart'), {
      credentials: 'same-origin',
      cache: 'no-store',
    });
    if (!res.ok) return null;
    return res.json();
  }

  async changeItem(key, quantity) {
    return this.fetch(getCartUrl('change'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
      credentials: 'same-origin',
    });
  }

  async add(variantId, quantity) {
    return window.fetch(getCartUrl('add'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
      credentials: 'same-origin',
    });
  }

  isSubscription(item) {
    if (item.selling_plan_allocation != null) return true;
    const title = (item.variant_title || '').toLowerCase();
    return title.startsWith('subscription') || title === 'abonnement';
  }

  async openDrawer() {
    const drawer = document.querySelector('cart-drawer-component');

    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch {}
    }

    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

    const togglers = document.querySelectorAll(
      '[data-cart-drawer-toggle], [aria-controls="cart-drawer"], .header__icon--cart, .js-open-cart'
    );
    for (const t of togglers) {
      try { t.click(); return; } catch {}
    }
  }
}

export function getCartUrl(action) {
  const urls = {
    cart: '/cart.js',
    add: '/cart/add.js',
    change: '/cart/change.js',
    update: '/cart/update.js',
    clear: '/cart/clear.js',
  };
  return urls[action] || null;
}

export function getCartBasePath(action) {
  const paths = {
    cart: '/cart',
    add: '/cart/add',
    change: '/cart/change',
    update: '/cart/update',
    clear: '/cart/clear',
  };
  return paths[action] || null;
}


const cart = new Cart();
export default cart;
